import { GridToolsTypes } from '../constants/gridtoolsConstants';

const setToolMode = (tool) => ({
    type: GridToolsTypes.SET_TOOL_MODE,
    tool, 
});

const setSnapMode = (snap) => ({
    type: GridToolsTypes.SET_SNAP_MODE,
    snap, 
});

const setProperties = (toolprops, save = true) => ({
    type: GridToolsTypes.SET_TOOL_PROPERTIES,
    toolprops, 
    save
});

const setSelectedGrid = (gridId) => ({
    type: GridToolsTypes.SET_SELECTED_GRID,
    gridId, 
});

const setLayers = (layers) => ({
    type: GridToolsTypes.SET_LAYERS,
    layers, 
});

const setSelectedLayer = (selectedLayer) => ({
    type: GridToolsTypes.SET_SELECTED_LAYER,
    selectedLayer, 
});

const setActiveGridId = (gridId) => ({
    type: GridToolsTypes.SET_ACTIVE_GRID,
    gridId, 
});

const setPropsGrid = (props) => ({
    type: GridToolsTypes.SET_PROPS_GRID,
    props, 
});

const setShapesSelected = (selected) => ({
    type: GridToolsTypes.SET_SHAPE_SELECTED,
    selected, 
});

const setLoadedGrid = (grid) => ({
    type: GridToolsTypes.SET_LOADED_GRID,
    grid, 
});

const setSyncRender = (render) => ({
    type: GridToolsTypes.SET_SYNC_RENDER_GRID,
    render, 
});

const setSyncRenderOperation = (op, data) => ({
    type: GridToolsTypes.SET_SYNC_RENDER_OPERATION_GRID,
    op,
    data
});

const setSyncPropsGrid = (props) => ({
    type: GridToolsTypes.SET_SYNC_PROPS_GRID,
    props
});

const recevingSignal = (signal) => ({
    type: GridToolsTypes.SIGNAL_GRID,
    signal, 
});

const recevingMeasure = (measure) => ({
    type: GridToolsTypes.MEASURE_GRID,
    measure, 
});

const recevingMoving = (moving) => ({
    type: GridToolsTypes.MOVING_GRID,
    moving, 
});

const clearMeasure = (measureId) => ({
    type: GridToolsTypes.MEASURE_CLEAR_GRID,
    measureId, 
});

const clearSignal = () => ({
    type: GridToolsTypes.SIGNAL_CLEAR_GRID
});

const propagateChanges = () => ({
    type: GridToolsTypes.PROPAGATE_CHANGES_GRID
});

const zoomChange = (zoom) => ({
    type: GridToolsTypes.ZOOM_CHANGE,
    zoom
});

const centerChange = (center) => ({
    type: GridToolsTypes.CENTER_CHANGE,
    center
});

const setTokenPresence = (tokens) => ({
    type: GridToolsTypes.SET_TOKEN_PRESENCE,
    tokens
});


const toggle3dDiceEnable = () => ({
    type: GridToolsTypes.DICE_3D_STATE_TOGGLE,
});


export default {
    setToolMode,
    setSnapMode,
    setProperties,
    setSelectedGrid,
    setActiveGridId,
    setPropsGrid,
    setLayers,
    setSelectedLayer,
    setShapesSelected,
    setLoadedGrid,
    setSyncRender,
    setSyncRenderOperation,
    setSyncPropsGrid,
    recevingSignal,
    recevingMeasure,
    clearMeasure,
    clearSignal,
    recevingMoving,
    propagateChanges,
    zoomChange,
    centerChange,
    setTokenPresence,
    toggle3dDiceEnable
};